export default {
    information: {
        content1Content:
            'さまざまな業種のお客さまにご利用いただいています。場所や時間に縛られず、請求業務の運用フローを大きく改善します。',
        content1Title: 'いつでも・どこでも請求業務ができる',
    },
    pageForm: {
        agreement: 'このフィールドは必須です。',
        businessType: {
            1: '法人',
            2: '個人事業主',
        },
        createAccount: 'アカウントを作成',
        employeeOptions: {
            1: '1～4名',
            2: '5～20名',
            3: '21～50名',
            4: '51～100名',
            5: '101～300名',
            6: '301～1,000名',
            7: '1,001名以上',
        },
        organizationHelper: '株式会社/合同会社/社団法人など',
        title: '無料アカウントをつくる',
    },
};
